import React from "react";
import "../PlaylistSquareTag/styles.scss";
import { Link } from "react-router-dom";
import Actions from "../Actions";
import defaultAlbumImg from "../../../../public/images/default-alblum-img.png";

export default ({ albumsSetter, album, showActions }) => {
  return (
    <div className="playlist-square-tag card">
      <Link
        to={album.user ? `/${album.user.slug}/albums/${album.id}` : null}
        className="card-body position-relative"
      >
        <div
          className="playlist-body d-flex flex-column justify-content-center"
          style={{
            backgroundImage:
              album.preview_image && album.preview_image.url
                ? `url('${album.preview_image.url}')`
                : `url('${defaultAlbumImg}')`,
          }}
        ></div>
        <div className="title">
          <p className="text-dark font-weight-bold m-0">{album.title}</p>
        </div>
      </Link>
      {showActions && (
        <div className="card-footer">
          <Actions object={album} setObject={albumsSetter} />
        </div>
      )}
    </div>
  );
};
